export const CASHBACK_STATUS = Object.freeze({
    PROVISIONAL: "provisional",
    READY: "ready",
    SENT: "sent",
    CANCELLED: "cancelled"
});

const STATUS_BADGES = {
    provisional: { variant: "secondary", text: "Provisional" },
    ready: { variant: "primary", text: "Siap Kirim" },
    sent: { variant: "success", text: "Terkirim" },
    cancelled: { variant: "warning", text: "Dibatalkan" }
};

export function getCashbackStatusBadge(status) {
    return STATUS_BADGES[status] || { variant: "light", text: "-" };
}

// Cancelled rows are treated like ready ones (spec 3.4).
export function canSend(status) {
    return status === CASHBACK_STATUS.READY || status === CASHBACK_STATUS.CANCELLED;
}
